import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageSquareWarning } from "lucide-react";
import api from "../api";
import { usePageTitle } from "../components/common";

export default function Reclamations() {
  usePageTitle("Réclamation");
  const [s, setS] = useState({});
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", order_number: "", subject: "", message: "", website: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => { api.get("/settings/public").then((r) => setS(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/reclamations", form);
      setDone(true);
      toast.success("Ta réclamation a bien été enregistrée ✨");
    } catch {
      toast.error("Une erreur est survenue.");
    } finally { setSending(false); }
  };

  if (done)
    return (
      <div className="container-x py-20 text-center fade-up max-w-lg">
        <MessageSquareWarning className="mx-auto text-[#C9A56A]" size={30} />
        <h1 className="mt-4 font-serif text-2xl text-[#5A3A4B]">Réclamation reçue</h1>
        <p className="mt-3 text-sm text-[#7A5D58]">Un accusé de réception vient de t'être envoyé. Nous reviendrons vers toi dans les meilleurs délais.</p>
      </div>
    );

  return (
    <div className="container-x py-12 sm:py-20 fade-up max-w-lg">
      <h1 className="font-serif text-3xl sm:text-4xl font-medium text-[#5A3A4B]">Réclamation</h1>
      <p className="mt-3 text-sm text-[#7A5D58] leading-relaxed">
        Avant toute médiation, adresse-nous ta réclamation. Tu peux aussi écrire directement à{" "}
        <a href={`mailto:${s.contact_email}`} className="text-[#5A3A4B] underline break-all">{s.contact_email}</a>.
      </p>
      <div className="gold-divider my-6 w-28" />
      <form onSubmit={submit} className="card-soft p-6 space-y-4" data-testid="reclamation-form">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="field-label">Prénom</label><input required className="field-input" value={form.first_name} onChange={set("first_name")} data-testid="reclam-first" /></div>
          <div><label className="field-label">Nom</label><input required className="field-input" value={form.last_name} onChange={set("last_name")} data-testid="reclam-last" /></div>
        </div>
        <div><label className="field-label">Email</label><input required type="email" className="field-input" value={form.email} onChange={set("email")} data-testid="reclam-email" /></div>
        <div><label className="field-label">Numéro de commande</label><input className="field-input" value={form.order_number} onChange={set("order_number")} placeholder="LMSP-…" data-testid="reclam-order" /></div>
        <div><label className="field-label">Objet</label><input required className="field-input" value={form.subject} onChange={set("subject")} data-testid="reclam-subject" /></div>
        <div><label className="field-label">Message</label><textarea required rows={5} className="field-input resize-none" value={form.message} onChange={set("message")} data-testid="reclam-message" /></div>
        <input type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
        <button type="submit" disabled={sending} className="btn-primary w-full" data-testid="reclam-submit">
          {sending ? "Envoi…" : "Envoyer ma réclamation"}
        </button>
      </form>
    </div>
  );
}
